// Load more articles
document.querySelectorAll('.blog-listing').forEach(wrapper => {

  const listing = wrapper.querySelector('.blog-listing-cards');

  const rows = wrapper.querySelector('.blog-listing-rows');

  const loadMoreWrapper = wrapper.querySelector('.bl-load-more-wrapper');

  const loadMoreButton = wrapper.querySelector('.bl-load-more');

  if (!listing || !loadMoreButton) return;

  const endpoint = '/apis/bloglistingapi/getblogarticles';
  const loadMoreText = loadMoreButton.innerText;

  const categories = wrapper.dataset.categories;
  wrapper.removeAttribute('data-categories');

  const pathSelected = wrapper.dataset.path;
  wrapper.removeAttribute('data-path');

  const rowcount = wrapper.dataset.rowcount;
  wrapper.removeAttribute('data-rowcount');

  const pagecount = wrapper.dataset.pagecount;
  wrapper.removeAttribute('data-pagecount');

  const headlinetag = wrapper.dataset.headlinetag;
  wrapper.removeAttribute('data-headlinetag');


  let nextPage = 1;
  let isLoading = false;
  let errorMessage = null;

  async function fetchBlogPosts() {
    if (isLoading) return;

    isLoading = true;

    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('pagenumber', nextPage);

    if (categories) {
      url.searchParams.set('categories', categories);
    } else {
      url.searchParams.set('categories', "");
    }

    url.searchParams.set('path', pathSelected);

    url.searchParams.set('rowcount', rowcount);

    url.searchParams.set('maxpagecount', pagecount);

    loadMoreButton.disabled = true;
    loadMoreButton.innerText = 'Loading...';

    try {
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error('Network response was not OK');
      }
      const data = (await res.json()) ?? {};

      nextPage++;

      refreshBlogListing(data);

      isLoading = false;
    } catch (error) {
      console.error('Failed to fetch posts', error);

      if (!errorMessage) {
        errorMessage = document.createElement('div');
        errorMessage.className = 'message message-error load-more-error';
        errorMessage.innerText = 'Something went wrong, please try again later';
        loadMoreButton.before(errorMessage);
      }

      loadMoreButton.disabled = false;
      loadMoreButton.innerText = loadMoreText;

      isLoading = false;
    }
  }

  loadMoreButton.addEventListener('click', fetchBlogPosts);

  function refreshBlogListing(data) {
    const blogPosts = data.posts;
    const canLoadMore = data.canLoadMoreBlogPosts;

    if (!canLoadMore || !blogPosts.length) {
      if (loadMoreWrapper) {
        loadMoreWrapper.remove();
      } else {
        loadMoreButton.remove();
      }
    }


    blogPosts.forEach(itemRow => {
      const fragment = document.createDocumentFragment();
      itemRow.forEach(post => {
        const card = createArticleCard(post);
        if (card) fragment.append(card);
      });

      const rowDiv = document.createElement('div');
      rowDiv.className = 'tile-wrapper blog-listing-cards';
      rowDiv.append(fragment);

      rows.append(rowDiv);

      errorMessage?.remove();

      if (canLoadMore) {
        loadMoreButton.disabled = false;
        loadMoreButton.innerText = loadMoreText;
      }
    });
  }

  function createArticleCard({ url, headline, teaser, image, postDate }) {
    if (!url || !headline) return null;

    const wrapper = document.createElement('a');
    wrapper.className = 'tile';
    wrapper.href = url;

    if (image) {
      const imgWrapper = document.createElement('div');
      imgWrapper.className = 'tile-image';

      const img = document.createElement('img');
      img.src = image;
      img.alt = '';

      imgWrapper.append(img);
      wrapper.append(imgWrapper);
    }

    const content = document.createElement('div');
    content.className = 'tile-content';

    const top = document.createElement('div');
    top.className = 'tile-top';

    const title = document.createElement(headlinetag === 'h2' ? 'h2' : 'h3');

    title.innerText = headline;

    top.append(title);
    content.append(top);

    if (teaser) {
      const text = document.createElement('div');
      text.className = 'tile-text';

      // Strip out any existing HTML and add paragraphs
      teaser = teaser
        .trim()
        .replace(/<p>/g, '')
        .replace(/<\/p>/g, '\n')
        .replace(/<[^>]*>/g, '')
        .trim()
        .split('\n')
        .map(p => `<p>${p.trim()}</p>`)
        .join('');

      text.innerHTML = teaser;

      content.append(text);
    }

    wrapper.append(content);

    return wrapper;
  }
});

